import styles from './AccountLimits.module.scss';
import { withStyles, formattedCurrency } from 'vopay';
import ProgressGraph from '../../components/ProgressGraph';
import { Title } from 'UI';

const cn = withStyles(styles);

type AccountLimitProps = {
  type: 'Inbound' | 'Outbound';
  title: string;
  remainingAmount: string;
  startingAmount: string;
  remaining: string;
  total: string;
  currency: string;
  primaryColor: string;
};

export default function AccountLimit({
  title,
  remainingAmount,
  startingAmount,
  remaining,
  total,
  currency,
  primaryColor,
}: AccountLimitProps) {
  return (
    <div className={cn('accountLimitsColumn')}>
      <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)' }}>
        {title}
      </Title>
      <div className={cn('graph')}>
        <ProgressGraph
          remaining={+remaining}
          total={+total}
          pathStrokeColor={primaryColor}
          trailStrokeColor={`${primaryColor}1A`}
          width="180px"
          height="180px"
        />
      </div>
      <div>
        <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)', fontSize: '13px' }}>
          {remainingAmount}
        </Title>
        <span>
          <Title level="6" emphasized={false}>
            {currency}
          </Title>
          <Title level="4">{formattedCurrency(remaining)}</Title>
        </span>
      </div>
      <div>
        <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)', fontSize: '13px' }}>
          {startingAmount}
        </Title>
        <span>
          <Title level="6" emphasized={false}>
            {currency}
          </Title>
          <Title level="6" style={{ fontWeight: 600 }}>
            {formattedCurrency(total)}
          </Title>
        </span>
      </div>
    </div>
  );
}
